<script lang="ts" setup>
import Customer from "@/customer/interfaces/Customer";
import {useSystemStore} from "@/stores/system.store";
import NotificationPreview from "@/core/components/notification-preview/NotificationPreview.vue";
import {NotificationTemplate} from "@/notification-template/interfaces";

const {environment} = useSystemStore();

defineProps<{
    customer: Customer;
    dates: Date[];
    notifications: NotificationTemplate[];
}>();
</script>

<template>
  <div>
    <h2 class="text-gray-dark mb-2">
      Le patient recevra :
    </h2>
    <div class="flex flex-col gap-y-6">
      <NotificationPreview
        type="push"
        :count="dates.length"
        when="3 jours avant chaque renouvellement"
        :content="`Message de la ${(environment as any)?.entity.name || 'pharmacie'}: n'oubliez pas de renouveler votre ordonnance. Retrouvez vos ordonnances sur https://www.apodis-sante.com/apodis/`"
      />
    </div>
  </div>
</template>
